import { isFunction } from 'lodash';

export default class RequestHelper {

	construct() {
		this.clearTimer = null;
	}

	delayRequest(time = 1000) {

		if( isFunction(this.clearTimer) ) {
			this.clearTimer();
		}

		return new Promise((resolve, reject) => {
			const delayTimer = setTimeout(resolve, time);

			this.clearTimer = () => {
				reject(new Error('Timer is cleared'));
				clearTimeout(delayTimer);
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/helpers/request-helper.js